import { useCallback, useState } from 'react';

import { getLocalStorage } from '@libs/storage';

const LOCAL_STORAGE_KEY = 'hide_promo_header';
const LOCAL_STORAGE = getLocalStorage();

export function usePromoHeaderToggle() {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    return Boolean(LOCAL_STORAGE.getItem(LOCAL_STORAGE_KEY));
  });
  const onCollapsedToggle = useCallback(
    (newValue: boolean) => {
      setIsCollapsed(newValue);
      LOCAL_STORAGE.setItem(LOCAL_STORAGE_KEY, newValue ? 'true' : '');
    },
    [setIsCollapsed],
  );

  return { isCollapsed, onCollapsedToggle };
}
